module.exports = __webpack_public_path__ + "img/close.b94063f8.svg";